'use strict';

var Scene = require('./scene').Scene;
var SlotWinPresenter = require('./slot-win-presenter').SlotWinPresenter;

var SlotScene = function (spec, math, slotConfig, slotWinPresenter ) {
    
    Scene.call(this);

    this.math = math;

    // как перебираются линии и ставки
    this.mathConfig = {
        lines : spec.lines_array,
        multipliers : spec.bets_array,
    };

    this.winFlowCB = null;

    this.$clockStream = null;

    this._showLinesTimeID = null;

    // текущее выставленное количество линий - нужно для их автоматического гашения
    // т.к. теперь неоткуда больше взять данные о текущем количестве линий
    this.activeLinesCount = 1;

    this.barrelContainer = new PIXI.Container();
    this.barrel = null;
    this.freeGamesBarrel = null;
    
    this.slotPresenter = slotWinPresenter || new SlotWinPresenter(this.math, slotConfig, this /*delegate*/);

    // действие по умолчанию
    this.slotPresenter.showBarrelElement = function showBarrelElement(idx){
        this.barrel.showSymbolWithIndex(idx);
    }.bind(this);

    this.slotPresenter.hideBarrelElement = function hideBarrelElement(idx) {
        this.barrel.hideSymbolWithIndex(idx);
    }.bind(this);
    
   
    this.logo = null;
    
    this.currentWinLabel = {};


    this.sndLines = [];
    this.sndBetUp = null;
    this.sndBetDown = null;
    this.sndCredits = null;
    this.sndWinflow = null;

    this.sndClockTick = sounds.get("res/common/sounds/clock_tick");
    this.sndClockTick.loop(true);
    this.sndClockTick.volume(0.4);
    
    this.forbidStop = function () {};

    this.lastReelStopped = -1;
};

SlotScene.prototype = Object.create(Scene.prototype);

SlotScene.prototype.constructor = SlotScene;

SlotScene.prototype.playClockSound = function () {
    if (this.sndClockTick && !this.sndClockTick.playing()) {
        this.sndClockTick.play();
    }
};

SlotScene.prototype.stopClockSound = function () {
    if (this.sndClockTick) {
        this.sndClockTick.stop();
    }
};

SlotScene.prototype.startClock = function () {
    if (this.$clockStream) {
        this.$clockStream.next(true);
    }
};

SlotScene.prototype.stopClock = function () {
    if (this.$clockStream) {
        this.$clockStream.next(false);
    }
};

    
/**
 * Получены данные для слота
 * {Object} mathStage - stage.math объект, может содержать специфические данные кроме символов
 * */
SlotScene.prototype.dataDidReceived = function (mathStage) {
};

SlotScene.prototype.setWinFlowCallback = function (cb) {
    this.winFlowCB = cb;
};

/**
 * эвауляция выигрыша на указанное значение
 * {Number} win - приращение (НЕ АБСОЛЮТНАЯ ВЕЛИЧИНА) выигрыша которое должно дополнительно донабежать в поле win в
 * */
SlotScene.prototype.flowWin = function (win) {
     if (this.winFlowCB) {
         this.winFlowCB(win);
     }
};


SlotScene.prototype.winFlowComplete = function (interrupts, regularWin) {
    if (this.sndWinflow) this.sndWinflow.stop();
};

/**
 * установка барабана
 * */
SlotScene.prototype.setBarrel = function(barrel) {
    this.barrel = barrel;
    this.barrelContainer.addChild(barrel.container);
};

/**
 * опциональная установка барабана для бесплатных игр (если требуется)
 * */
SlotScene.prototype.setFreegamesBarrel = function (barrel) {
    this.freeGamesBarrel = barrel;
    this.barrelContainer.addChild(barrel.container);
};

/**
 * скытие активных линий
 * */
SlotScene.prototype.hideActiveLines = function () {
    for (var i = 0; i < this.activeLinesCount; i++) {
        this.slotPresenter.hideLine(i);
    }
};

/**
 * изначальный показ необходимого кол-ва плашек на сцене в момент загрузки игры
 * */
SlotScene.prototype.onDefaultState = function (lines, multiplier) {
    for (var i = 0; i < lines; i++) {
        this.slotPresenter.showActiveBillets(i);
    }
    for (i = lines; i < this.math.linesNumber(); i++) {
        this.slotPresenter.hideActiveBillets(i);
    }
};

/**
 * инициация показа выигрыша в обычной игре
 * {Object} info - данные: stage.math от сервера, bet - ставка и линии
 * */
SlotScene.prototype.showWin = function (info) {
    this.math.spin(info.math.symbols, info.bet.lines, info.bet.multiplier);
    this.slotPresenter.showWin(this.slotPresenter, this.math);
    if (this.sndWinflow) this.sndWinflow.play();
};

/**
 *
 * */
SlotScene.prototype.showWinBeforeFreeGames = function (stageMath, done) {
};

SlotScene.prototype.showWinBeforeBonus = function (stageMath, done) {
};

/**
 *
 * */
SlotScene.prototype.interruptShowWin = function () {
    this.slotPresenter.interruptShowWin(this.slotPresenter, this.math);
    
    // this.logo.alpha = 1;
    // this.logo.visible = true;
};

/**
 *
 * */
SlotScene.prototype.startSpin = function () {
    // очищаем ранее установленный таймер автоскрытия линий
    if (this._showLinesTimeID) {
        clearTimeout(this._showLinesTimeID);
    }

    // принудительно скрываем линии
    this.hideActiveLines();
};

/**
 *
 * */
SlotScene.prototype.linesDidChange = function (newValue, oldValue) {
    
    var lineGroup = this.mathConfig.lines.indexOf(newValue);
    if (lineGroup >= 0) {
        if ( this.sndLines && this.sndLines[ lineGroup ] ) this.sndLines[lineGroup].play()
    }
    
    // показываем нужное кол-во линий
    for (var i = 0; i < newValue; i++) {
        
        if (this.slotPresenter.lineIsVisible(i)) continue;
        
        this.slotPresenter.showLine(i);
        
        this.slotPresenter.fadeInActiveBillets(i);
    }
    
    // оставшиея, если есть, прячем
    for (i = newValue; i < this.math.linesNumber(); i++) {
        
        if (this.slotPresenter.lineIsVisible(i)) {
            this.slotPresenter.hideLine(i);
        }
        
        this.slotPresenter.fadeOutActiveBillets(i);
    }
    
    // очищаем ранее установленный таймер автоскрытия линий
    if (this._showLinesTimeID) {
        clearTimeout(this._showLinesTimeID);
    }
    
    this.activeLinesCount = newValue;
    
    // взводим таймер автоскрытия линий
    this._showLinesTimeID = setTimeout(this.hideActiveLines.bind(this), 4000);
};

/**
 *
 * */
SlotScene.prototype.multiplierDidChange = function (newValue, oldValue) {
    if ( this.sndBetUp && newValue > oldValue) {
        this.sndBetUp.play();
    }
    else if ( this.sndBetDown && newValue < oldValue) {
        this.sndBetDown.play();
    }
};

SlotScene.prototype.creditsDidChange = function (newValue, oldValue) {
};

/**
 *
 * */
SlotScene.prototype.winShowDidStart = function (freegames) {
    
    var fadeOutWidget = freegames ? this.freegamesCounterLabel : this.logo;
    
    if (this.fadeInWidgetTween) this.fadeInWidgetTween.stop();
    
    if (fadeOutWidget) {

        fadeOutWidget.alpha = 1;
        this.fadeOutWidgetTween = new TWEEN.Tween(fadeOutWidget)
            .to({alpha: 0}, 200)
            .onComplete(function () {
                fadeOutWidget.visible = false;
            })
            .start();
    }
    
    this.currentWinLabel.alpha = 1;
    this.currentWinLabel.visible = true;
    this.currentWinLabel.text = '';
};

/**
 *
 * */
SlotScene.prototype.winShowDidFinish = function (freegames) {
    
    var fadeInWidget = freegames ? this.freegamesCounterLabel : this.logo;
    
    if (this.fadeOutWidgetTween) this.fadeOutWidgetTween.stop();
    
    if (fadeInWidget) {

        fadeInWidget.visible = true;
        fadeInWidget.alpha = 0;

        this.fadeInWidgetTween = new TWEEN.Tween(fadeInWidget)
            .to({alpha: 1}, 200)
            .start();
    }
    
    var self = this;
    
    var winLabelTween = new TWEEN.Tween(this.currentWinLabel)
        .to({alpha: 0}, 200)
        .onComplete(function () {
            self.currentWinLabel.visible = false;
            self.currentWinLabel.text = '';
        })
        .start();
};

/**
 *
 * */
SlotScene.prototype.lineDidShow = function (line, win) {
    this.currentWinLabel.text = 'LINE ' + (line + 1) + ' WINS ' + win;
};

/**
 *
 * */
SlotScene.prototype.lineDidHide = function (line) {

};

/**
 *
 * */
SlotScene.prototype.scattersDidShow = function (win) {
    this.currentWinLabel.text = 'SCATTERS WIN ' + win;
};

/**
 *
 * */
SlotScene.prototype.scattersDidHide = function () {
    this.currentWinLabel.text = "";
};


/**
 *
 * */
SlotScene.prototype.barrelDidStop = function () {
};


SlotScene.prototype.reelStopHandler = function (index, isFreegames) {

    var b = (isFreegames) ? ((this.freeGamesBarrel) ? this.freeGamesBarrel : this.barrel ) : this.barrel;

    for (var i = this.lastReelStopped + 1; i < index + 1; ++i) {

        if (b.reels[i].isFreezed()) {
            continue;
        }

        if (isFreegames) {
            this.freeReelDidStop(i);
        }
        else {
            this.reelDidStop(i);
        }
    }

    // если остановился последний барабан, сбрасываем lastReelStopped до начального значения -1
    this.lastReelStopped = (index === b.reels.length - 1) ? -1 : index;
};

/**
 *
 * */
SlotScene.prototype.reelDidStop = function (index) {
};



// freegames

/**
 *
 * */
SlotScene.prototype.switchToFreeGames = function (stageMath, done) {
    done();
};

/**
 *
 * */
SlotScene.prototype.switchToMainGame = function (stageMath, done) {
    this.logo.alpha = 1;
    this.logo.visible = true;
    
    done();
};

/**
 *
 * */
SlotScene.prototype.hideFreeGamesTable = function (done) {
    done();
};

SlotScene.prototype.hideBonusTable = function (done) {
    done();
};

/**
 *
 * */
SlotScene.prototype.showFreeGamesFinishTable = function (stageMath, lines, multiplier, done, totalWin) {
    done();
};

/**
 *
 * */
SlotScene.prototype.freeStartSpin = function (currentSpin, totalSpins, stageMath) {
    
};

/**
 *
 * */
SlotScene.prototype.freeBarrelDidStop = function () {
    this.barrelDidStop();
};

/**
 *
 * */
SlotScene.prototype.freeReelDidStop = function (index) {
    this.reelDidStop(index);
};

/**
 *
 * */
SlotScene.prototype.freeShowWinBeforeFreeGames = function (info, done) {
    done();
};

/**
 *
 * */
SlotScene.prototype.freeShowWin = function (info, done) {
    done();
};

/**
 *
 * */
SlotScene.prototype.noFreeWin = function (info, done) {
    done();
};

module.exports.SlotScene = SlotScene;



//////////////////
// WEBPACK FOOTER
// ./src/library/slot-scene.js
// module id = 106
// module chunks = 0